import { get } from 'lodash';
import { convertHexToRGB } from '../../utils';

const styles = (theme) => ({
  root: {
    backgroundColor: get(theme, 'color.white'),
    margin: "0 36px",
    padding: "12px 36px 100px 36px",
  },
  formSection: {
    maxWidth: "840px",
  },
  flex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  fontContainer: {
    fontWeight: 700,
  },
  submitButton: {
    '&:focus': {
      border: `1px solid #FFFFFF`,
      outline: `1px solid ${get(theme, 'color.primaryButtonBackground')}`,
    },
  },
  textError: {
    color: `${get(theme, 'color.error')} !important`,
  },
  warning: {
    border: `1px solid ${get(theme, 'color.warning')}`,
    backgroundColor: `${convertHexToRGB(get(theme, 'color.warning'), 0.1)}`,
    padding: 12,
    maxWidth: "820px",
    marginBottom: "2rem",
  },

  flexNonBetween: {
    display: "flex",
    alignItems: "center",
  },
  warningText: {
    marginLeft: 7,
  },
  toolTipContainer: {
    position: "relative",
  },
  helpIcon: {
    color: get(theme, 'color.primaryButtonBackground'),
  },
  commonName: {
    position: "absolute",
    top: 0,
    left: 105,
    width: 22,
  },
  aliasName: {
    position: "absolute",
    top: 0,
    left: 75,
    width: 22,
  },
  certSuccessMessage: {
    border: `1px solid ${get(theme, 'color.gray')}`,
    marginBottom: "1rem",
  },
  successIcon: {
    color: get(theme, 'color.green'),
  },
  successMessageText: {
    marginLeft: "1rem",
  },
  errorDialog: {
    width: "35% !important",
  },
  commonNameToolTip: {
    color: get(theme, 'color.white'),
  },
  commonNameRecommend: {
    fontWeight: "bold",
    color: get(theme, 'color.white'),
  },
  horizontaLine: {
    marginTop: "-7px",
  },
  serverCertificateTitle: {
    fontWeight: 700,
    marginTop: "1rem",
  },
  fileDropLabelClass: {
    fontSize: '14px !important',
  },
})
export default styles;